import axios from 'axios';
import { showToast } from 'vant';
import router from '@/router';
// 创建axios实例
const instance = axios.create({
  // 基础URL配置
  baseURL: import.meta.env.VITE_API_BASE_URL,
  // 请求超时时间
  timeout: 30000,
  // 请求头设置
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
});
// 移除在文件顶部的shop_clerk_uuid获取
// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.token = `${token}`;
      config.headers.firm_uuid = 6;
      // 每次请求都从localStorage获取最新的shop_clerk_uuid
      config.headers.shop_clerk_uuid = localStorage.getItem('shop_clerk_uuid');
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code !== 200) {
      if (res.code === -2) {
        showToast('未授权，请重新登录');
        //清除所有缓存
        localStorage.clear();
        // 跳转到登录页
        router.replace({ path: "/login" });
        return Promise.reject(new Error(res.message || '未授权，请重新登录'));
      } else {
        showToast(res.msg || '请求失败');
        return Promise.reject(new Error(res.msg || '请求失败'));
      }
    }
    return res;
  },
  error => {
    console.error('响应错误:', error);
    if (error.response) {
      switch (error.response.status) {
        case 401:
          showToast('未授权，请重新登录');
          //清除所有缓存
          localStorage.clear();
          // 跳转到登录页
          router.replace({ path: "/login" });
          break;
        case 403:
          showToast('拒绝访问');
          break;
        case 404:
          showToast('请求地址不存在');
          break;
        case 500:
          showToast('服务器内部错误');
          break;
        default:
          showToast(`请求失败: ${error.response.status}`);
      }
    } else if (error.request) {
      showToast('网络错误，请检查网络连接');
    } else {
      showToast('请求配置错误');
    }
    return Promise.reject(error);
  }
);

// 导出常用请求方法
export default {
  // get请求
  get(url, params = {}) {
    // 每次请求都从localStorage获取最新的shop_clerk_uuid
    params.shop_clerk_uuid = localStorage.getItem('shop_clerk_uuid');
    params.firm_uuid = 6;
    return instance.get(url, { params });
  },

  // post请求
  post(url, data = {}) {
    // 每次请求都从localStorage获取最新的shop_clerk_uuid
    data.shop_clerk_uuid = localStorage.getItem('shop_clerk_uuid');
    data.firm_uuid = 6;
    return instance.post(url, data);
  },
  // 原始实例，方便使用其他方法
  instance
};